import React from 'react';
import GroupRow from './GroupRow';

export type RowClickEvent = (evt: React.MouseEvent<HTMLDivElement>, index: number) => void;

export interface GroupRowsProps<T> {
  canvasWidth: number;
  lineCount: number;
  groupHeights: number[];
  onRowClick: RowClickEvent;
  onRowDoubleClick: RowClickEvent;
  clickTolerance?: number;
  groups: T[];
  horizontalLineClassNamesForGroup?: (group: T) => string[];
  onRowContextClick: RowClickEvent;
}

function GroupRows<T>({
  canvasWidth,
  lineCount,
  groupHeights,
  onRowClick,
  onRowDoubleClick,
  clickTolerance,
  groups,
  horizontalLineClassNamesForGroup,
  onRowContextClick,
}: GroupRowsProps<T>) {
  const lines: React.ReactNode[] = [];

  for (let i = 0; i < lineCount; i += 1) {
    lines.push(
      <GroupRow
        key={`horizontal-line-${i}`}
        clickTolerance={clickTolerance}
        onContextMenu={(evt) => onRowContextClick(evt, i)}
        onClick={(evt) => onRowClick(evt, i)}
        onDoubleClick={(evt) => onRowDoubleClick(evt, i)}
        isEvenRow={i % 2 === 0}
        group={groups[i]}
        horizontalLineClassNamesForGroup={horizontalLineClassNamesForGroup}
        style={{
          width: `${canvasWidth}px`,
          height: `${groupHeights[i]}px`,
        }}
      />
    );
  }

  return <div className="rct-horizontal-lines">{lines}</div>;
}

GroupRows.displayName = 'GroupRows';

export default GroupRows;
